'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);



let page

class Page
{
    constructor(view='')
    {
        this.DOM = {
          view:view
        }
        this.FX = {}
        this.classView = 'currentView--home'

        //? Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
        Env.framework.UI.storytelling.destroy()
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            Env.framework.UI.storytelling.updateDOM(this.DOM.view)
            Env.framework.UI.smoothScrollRefresh()
            this.fx()
        }, 200);
    }

    fx()
    {
      const titleH1 = this.DOM.view.querySelector(".introduction-block h1")
      const titleH2 = this.DOM.view.querySelector(".introduction-block h2")
      Env.smoothInstance.effects(titleH1, { speed: 1 });
      Env.smoothInstance.effects(titleH2, { speed: 1.1 });

      this.FX.h1 = new SplitText(titleH1, { type:"words"})
      this.FX.h2 = new SplitText(titleH2, { type:"words"})

      gsap.set(this.FX.h1.words, { autoAlpha: 0})
      gsap.set(this.FX.h2.words, { autoAlpha: 0})

      //? H1
      this.tlH1 = gsap.timeline({ scrollTrigger : {
        trigger:titleH1,
        start:'top 70%'
      } })
      this.tlH1.add([
        gsap.to(
          this.FX.h1.elements[0].querySelectorAll('em div'),
          {
            autoAlpha:1,
            ease:'cubic.out',
            duration:2,
            stagger:.02
          }
        )
      ])
      this.tlH1.add([
        gsap.to(
          this.FX.h1.words,
          {
            autoAlpha:1,
            ease:'cubic.out',
            duration:1,
            stagger:.01
          }
        )
      ],'-=1')

      //? H2
      this.tlH2 = gsap.timeline({ scrollTrigger : {
        trigger:titleH2,
        start:'top 70%'
      } })
      this.tlH2.add([
        gsap.to(
          this.FX.h2.elements[0].querySelectorAll('em div'),
          {
            autoAlpha:1,
            ease:'cubic.out',
            duration:2,
            stagger:.02
          }
        )
      ])
      this.tlH2.add([
        gsap.to(
          this.FX.h2.words,
          {
            autoAlpha:1,
            ease:'cubic.out',
            duration:1,
            stagger:.01
          }
        )
      ],'-=1')

      //? Missions
      const missionBlock = this.DOM.view.querySelector('.jsMissions')

      gsap.fromTo(
        missionBlock.querySelectorAll('li'),
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:Env.eases.ride,
          duration:1,
          stagger:.1,
          scrollTrigger:{
            trigger:missionBlock,
            start:'top 50%'
          }
        }
      )

      //? Contact
      Env.smoothInstance.effects(this.DOM.view.querySelector('.contact-block .jsTitle'), { speed: .7 });
      Env.smoothInstance.effects(this.DOM.view.querySelector('.contact-block .jsActions'), { speed: 1.2 });
    }


    intro()
    {
        console.log('intro');
    }

}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
